import script from "./advantage-card.vue?vue&type=script&setup=true&lang=js"
export * from "./advantage-card.vue?vue&type=script&setup=true&lang=js"

import "./advantage-card.vue?vue&type=style&index=0&id=550e067f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-550e067f"]])

export default __exports__